<template>
  <div>
    <div class="wrapper wrapper-content  animated fadeInRight">
      <div class="ibox">
        <div class="tabs-container">
          <ul class="nav nav-tabs" role="tablist">
            <li class="active"><a class="nav-link" data-toggle="tab" href="#statements" @click="activeComponent = 'statementsTab'">Statements</a></li>
            <li><a class="nav-link" data-toggle="tab"  href="#tlds" @click="activeComponent = 'tldsTab'">Tlds</a></li>
          </ul>
          <div class="tab-content">
            <div class="tab-pane ibox-content active" role="tabpanel" id="feed">
              <div class="row">
                <component v-if="activeComponent" :is="activeComponent"></component>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import TldsTab from './Billing/Tabs/Tlds'
import HostingTab from './Billing/Tabs/Hosting'
import StatementsTab from './Billing/Tabs/Statements'

export default {
  data () {
    return {
      activeComponent: 'statementsTab'
    }
  },
  components: {
    tldsTab: TldsTab,
    statementsTab: StatementsTab,
    hostingTab: HostingTab
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/Admin/Billing.vue